"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _text = _interopRequireDefault(require("@ux/text"));
const _excluded = ["inputRef", "onChange"],
  _excluded2 = ["as", "label", "invalid", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_RADIO_CLASSNAME = 'ux-radio';
const asOptions = ['option'];

/**
 * Creates a native HTML input element
 *
 * @param {Object} props - Component properties
 * @param {Boolean} [props.checked] - Determines if the input should be checked
 * @param {Boolean} [props.disabled] - Determines if the input should be disabled
 * @param {String} props.id - Sets an `id` on the input
 * @param {Element} props.inputRef - Sets the `ref` for the input element
 * @param {String} props.name - Sets the name of the input
 * @param {Function} [props.onBlur] - Callback for when the component loses focus
 * @param {Function} [props.onChange] - Callback when the value changes
 * @param {Boolean} [props.readOnly] - Determines if the input should be readonly
 * @param {Number} [props.tabIndex] - Sets the tabIndex
 * @param {Node} [props.value] - Sets the value of the input
 * @returns {Component} - HTML Input Element
 */
function Input(props) {
  const _ref = props || {},
    {
      inputRef,
      onChange = Function.prototype
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  // style is explicitly omitted, do not override.
  delete rest.style;
  const _onChange = (0, _react.useCallback)(ev => {
    onChange(ev.target.checked, {
      event: ev
    });
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    className: `${UX_RADIO_CLASSNAME}-input`,
    onChange: _onChange,
    ref: inputRef,
    type: "radio"
  }, rest));
}
Input.propTypes = {
  /** Determines if the input should be checked */
  checked: _propTypes.default.bool,
  /** Determines if the input should be disabled */
  disabled: _propTypes.default.bool,
  /** Sets an `id` on the input */
  id: _propTypes.default.string.isRequired,
  /** Sets the `ref` for the input element */
  inputRef: _propTypes.default.any,
  /** Sets the name of the input */
  name: _propTypes.default.string.isRequired,
  /** Callback for when the component loses focus */
  onBlur: _propTypes.default.func,
  /** Callback when the value changes */
  onChange: _propTypes.default.func,
  /** Determines if the input should be readonly */
  readOnly: _propTypes.default.bool,
  /** Sets the value of the input */
  value: _propTypes.default.node
};

/**
 * Creates a radio component
 *
 * @param {Object} props - Component properties
 * @param {String} [props.as] - Display component in different way
 * @param {String} [props.className] - Add className to root component
 * @param {Boolean} [props.checked] - Determines if the input should be checked
 * @param {Boolean} [props.disabled] - Determines if the input should be disabled
 * @param {String} props.id - Sets an `id` on the input
 * @param {Boolean} [props.invalid] - Determines if the component should be invalid
 * @param {Node} [props.label] - Provides the text describing the input's value
 * @param {String} props.name - Sets the name of the input
 * @param {Function} [props.onChange] - Callback when the value changes
 * @param {Boolean} [props.readOnly] - Determines if the input should be readonly
 * @param {Node} [props.value] - Sets the value of the input
 * @returns {Component} - Radio component
 */
const Radio = /*#__PURE__*/_react.default.forwardRef(function Radio() {
  let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let ref = arguments.length > 1 ? arguments[1] : undefined;
  let {
      as,
      label,
      invalid,
      className
    } = _ref2,
    inputProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  const {
    disabled,
    id,
    readOnly
  } = inputProps || {};
  return /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "input",
    emphasis: invalid && 'critical',
    className: (0, _classnames.default)(`${UX_RADIO_CLASSNAME}-shell`, className),
    "data-version": "2400.6",
    "aria-disabled": disabled,
    "aria-readonly": readOnly,
    "aria-invalid": invalid,
    role: as === 'option' ? 'option' : null
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `${UX_RADIO_CLASSNAME}-lineheightbox`,
    "data-lineheight": label && 'I'
  }, /*#__PURE__*/_react.default.createElement(Input, (0, _extends2.default)({}, inputProps, {
    inputRef: ref
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: `${UX_RADIO_CLASSNAME}-indicator`
  })), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: `${UX_RADIO_CLASSNAME}-label`
  }, label));
});
Radio.propTypes = {
  /** Determines if the input should be checked */
  checked: _propTypes.default.bool,
  /** Determines if the input should be disabled */
  disabled: _propTypes.default.bool,
  /** Sets an `id` on the input */
  id: _propTypes.default.string.isRequired,
  /** Sets the name of the input */
  name: _propTypes.default.string.isRequired,
  /** Callback for when the component loses focus */
  onBlur: _propTypes.default.func,
  /** Callback when the value changes */
  onChange: _propTypes.default.func,
  /** Determines if the input should be readonly */
  readOnly: _propTypes.default.bool,
  /** Sets the value of the input */
  value: _propTypes.default.node,
  /** Display component in different way */
  as: _propTypes.default.oneOf(asOptions),
  /** className for the root component */
  className: _propTypes.default.string,
  /** Determines if the component should be invalid */
  invalid: _propTypes.default.bool,
  /** Provides the text describing the input's value */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element])
};
Radio.displayName = 'Radio';
var _default = exports.default = Radio;